import { ThemeLayout } from '../../front/lib/ThemeLayout';
import { createApp } from 'vue';
import SearchApp from './SearchApp.vue';
import { theme } from '../../front/Theme';
export class Search extends ThemeLayout {
    constructor() {
        super(...arguments);
        this.appEl = this.getElementById('app');
    }
    init() {
        this.initSearch();
    }
    async initSearch() {
        const app = createApp(SearchApp, { searchLayout: this });
        app.use(theme().i18n);
        const appInstance = app.mount(this.appEl);
    }
    static buildUrl(args) {
        const url = new URL(window.location.origin);
        url.searchParams.set('s', args.query);
        if (args.indexUid) {
            url.searchParams.set(Search.UriParam.IndexUid, args.indexUid);
        }
        return url;
    }
}
/**
 * Use namespace to declare any related types inside the layout
 */
(function (Search) {
    let UriParam;
    (function (UriParam) {
        UriParam["IndexUid"] = "i";
        UriParam["Query"] = "s";
    })(UriParam = Search.UriParam || (Search.UriParam = {}));
})(Search || (Search = {}));
